import $ from 'jquery';
import LazyLoad from "vanilla-lazyload";


class LazyLoader {

  init() {
    this.initImagesLazyLoad();
     this.initLazyloadSpecials();
    return this;
  }

  initImagesLazyLoad() {
    const imagesLazyLoadOptions = {
    	elements_selector: ".lazyload",
    	threshold: 0,
    	class_loading: 'lazyloading',
    	class_loaded: 'lazyloaded',
    	callback_loaded: element => {
    	  $(element).parent().addClass('rc--lazyload');
    	},
    };

    this.imagesLazyLoad = new LazyLoad(imagesLazyLoadOptions);
    return this;
  }

  loadAllImagesLazyLoad() {
    this.imagesLazyLoad.loadAll();
    return this;
  }

  updateImagesLazyLoad() {
    this.imagesLazyLoad.update();
    return this;
  }


    sameCategoriesFunction() {

    $('.featured-products.products-same-category .products').slick({
            "focusOnSelect": true,
            "slidesToShow": 4,
            "slidesToScroll": 4,
            "infinite": true,
            "autoplay": true,
            "lazyLoad": 'ondemand',
            "autoplaySpeed": 4000,
             "prevArrow":'<button class="slick-prev slick-arrow bg-transparent border-0" aria-label="Previous" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_left</i></button>',
             "nextArrow":'<button class="slick-next slick-arrow bg-transparent border-0" aria-label="Next" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_right</i></button>',     
            "responsive": [
              {
                "breakpoint": 1200,
                "settings": {
                  "slidesToShow": 3
                }
              },
              {
                "breakpoint": 992,
                "settings": {
                  "slidesToShow": 3
                }
              },
              {
                "breakpoint": 768,
                "settings": {
                  "slidesToShow": 1
                }
              },
              {
                "breakpoint": 576,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1
                }
              }
            ]
    });
    return this;
  }
  specialsFunction() {

    $('.featured-products .specials').slick({
            "focusOnSelect": true,
            "slidesToShow": 4,
            "slidesToScroll": 4,
            "infinite": true,
            "autoplay": true,
            "lazyLoad": 'ondemand',
            "autoplaySpeed": 4000,
             "prevArrow":'<button class="slick-prev slick-arrow bg-transparent border-0" aria-label="Previous" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_left</i></button>',
             "nextArrow":'<button class="slick-next slick-arrow bg-transparent border-0" aria-label="Next" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_right</i></button>',     
            "responsive": [
              {
                "breakpoint": 1200,
                "settings": {
                  "slidesToShow": 3
                }
              },
              {
                "breakpoint": 992,
                "settings": {
                  "slidesToShow": 3
                }
              },
              {
                "breakpoint": 768,
                "settings": {
                  "slidesToShow": 1
                }
              },
              {
                "breakpoint": 576,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1
                }
              }
            ]
    });
    return this;
  }

  cardCategoriesFunction()
  {
    $('.categoriesCards .products').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow:'<button class="slick-prev slick-arrow bg-transparent border-0" aria-label="Previous" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_left</i></button>',
    nextArrow:'<button class="slick-next slick-arrow bg-transparent border-0" aria-label="Next" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_right</i></button>',     
    mobileFirst: true,
    responsive: [
          {
                  breakpoint: 768,
                  settings: 'unslick'
          }
    ]
    });
  }

  manufactureFunction()
  {
    $('.manufactures-list').slick({
            "focusOnSelect": true,
            "infinite": true,
            "autoplay": true,
            "autoplaySpeed": 4000,
            "lazyload":'ondemand',
            "slidesToShow": 4,
            "slidesToScroll": 4,
            "prevArrow":'<button class="slick-prev slick-arrow bg-transparent border-0" aria-label="Previous" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_left</i></button>',
            "nextArrow":'<button class="slick-next slick-arrow bg-transparent border-0" aria-label="Next" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_right</i></button>',     
            "responsive": [
              {
                "breakpoint": 1200,
                "settings": {
                  "slidesToShow": 4
                }
              },
              {
                "breakpoint": 992,
                "settings": {
                  "slidesToShow": 4
                }
              },
              {
                "breakpoint": 768,
                "settings": {
                  "slidesToShow": 1
                }
              },
              {
                "breakpoint": 576,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1
                }
              }
            ]
    });
  }

    manufactureCmsFunction()
  {
    $('.manufactures-list-cms').slick({
            "focusOnSelect": true,
            "infinite": true,
            "autoplay": true,
            "autoplaySpeed": 4000,
            "lazyload":'ondemand',
            "slidesToShow": 3,
            "slidesToScroll": 3,
            "prevArrow":'<button class="slick-prev slick-arrow bg-transparent border-0" aria-label="Previous" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_left</i></button>',
            "nextArrow":'<button class="slick-next slick-arrow bg-transparent border-0" aria-label="Next" type="button" style="display: flex;"><i class="material-icons text-primary">keyboard_arrow_right</i></button>',     
            "responsive": [
              {
                "breakpoint": 1200,
                "settings": {
                  "slidesToShow": 3
                }
              },
              {
                "breakpoint": 992,
                "settings": {
                  "slidesToShow": 2
                }
              },
              {
                "breakpoint": 768,
                "settings": {
                  "slidesToShow": 1
                }
              },
              {
                "breakpoint": 576,
                "settings": {
                  "slidesToShow": 1,
                  "slidesToScroll": 1
                }
              }
            ]
    });
  }


  lazyloadTrustedshopframe() {

      $('head').append('<script src="https://integrations.etrusted.com/applications/widget.js/v2" defer async></script>');

    return this;
  }

  faqsFunction() {
      jQuery.getScript("/modules/faqs/views/js/faq.js");
      jQuery.getScript("/modules/faqs/views/js/faqs_form.js");

    return this;
  }

  initLazyloadSpecials() {


    const lazyspecials = new LazyLoad({
      elements_selector: ".specials",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.specialsFunction, // Assigning the function
    });

    const lazycards = new LazyLoad({
      elements_selector: ".categoriesCards",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.cardCategoriesFunction, // Assigning the function
    });

    const lazytrusted = new LazyLoad({
      elements_selector: ".eTrusted-widget",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.lazyloadTrustedshopframe, // Assigning the function
    });

    const lazymanu = new LazyLoad({
      elements_selector: ".manufactures-list",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.manufactureFunction, // Assigning the function
    });

        const lazymanucms = new LazyLoad({
      elements_selector: ".manufactures-list-cms",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.manufactureCmsFunction, // Assigning the function
    });

    const lazysamecategory = new LazyLoad({
      elements_selector: ".products-same-category",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.sameCategoriesFunction, // Assigning the function
    });

    const lazyfaqs = new LazyLoad({
      elements_selector: ".product-tabs",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.faqsFunction, // Assigning the function
    });

    return this;
  }



/*  lazyloadFacebookframe() {
    // if facebookpage exists and it's not yet loaded
    if ($('#facebookpage').length && !$('#facebook-lazyloader').length) {
      let src = $('#facebookpage [name="script-url"]').attr('value');
      let facebook_external_script = `<script id="facebook-lazyloader" crossorigin="anonymous" src="${src}"></script>`;
      $('body').append(facebook_external_script);
    }
    return this;
  }*/

/*  initLazyloadFacebookframe() {
    // LazyLoad Facebook frame script to be executed
    // only when the DOM element (#facebookpage) enters the viewport

    const lazyfacebookframe = new LazyLoad({
      elements_selector: "#facebookpage",
      unobserve_entered: true, // <- Avoid executing the function multiple times
      callback_enter: this.lazyloadFacebookframe, // Assigning the function
    });
    return this;
  }*/

}





const lazyLoaderInstance = new LazyLoader();
lazyLoaderInstance.init();

Object.freeze(lazyLoaderInstance);

export default lazyLoaderInstance;